export default __webpack_public_path__ + "static/media/instagram-icon.08baac88.svg";